exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".historical_filter ::v-deep label[data-v-eb728a46]{font-size:1.1rem;font-weight:700;margin-bottom:.25rem}.drafts-filter[data-v-eb728a46]{margin-bottom:.5rem}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Committees/Dashboard/CommitteeDashboard.vue"],"names":[],"mappings":"AACA,mDACE,iBAAkB,AAClB,gBAAkB,AAClB,oBAAuB,CACxB,AACD,gCACE,mBAAsB,CACvB","file":"CommitteeDashboard.vue","sourcesContent":["\n.historical_filter ::v-deep label[data-v-eb728a46] {\n  font-size: 1.1rem;\n  font-weight: bold;\n  margin-bottom: 0.25rem;\n}\n.drafts-filter[data-v-eb728a46] {\n  margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eb728a46","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Committees/Dashboard/CommitteeDashboard.vue
// module id = 1324
// module chunks = 0